var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"list-unstyled"},[_c('li',{class:_vm.$style.item},[_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-3"},[_c('div',[_vm._v("Notification")]),_c('div',{staticClass:"text-muted"},[_vm._v("Haven't any notifications")])])
}]

export { render, staticRenderFns }